import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface ToastItem {
  message: string;
  type: string;
  id: string;
}

export interface ToastState {
  active: ToastItem[];
  queue: ToastItem[];
}

const initialState: ToastState = {
  active: [],
  queue: [],
};

const toastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    showToast: {
      prepare(message: string, type: string = 'default') {
        return {
          payload: {
            message,
            type,
            id: `${Date.now()}-${Math.random()}`,
          } satisfies ToastItem,
        };
      },
      reducer(state, action: PayloadAction<ToastItem>) {
        if (state.active.length < 3) {
          state.active.push(action.payload);
        } else {
          state.queue.push(action.payload);
        }
      },
    },
    hideToast(state) {
      state.active.shift();
      if (state.active.length < 3 && state.queue.length > 0) {
        const next = state.queue.shift();
        if (next) state.active.push(next);
      }
    },
  },
});

export const { showToast, hideToast } = toastSlice.actions;

export const toastReducer = toastSlice.reducer;
